import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c15771"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "待办", -1))
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_miezz_modal, {
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue) = $event)),
      key: _ctx.id
    }, {
      header: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_form_item, {
          label: "仅显示我的任务",
          style: {"display":"inline-flex","margin":"0px","font-size":"14px"},
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.onlyMy,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyMy) = $event)),
              "active-value": true,
              "inactive-value": false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.taskSource,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.taskSource) = $event)),
            type: "card",
            "tab-position": "top"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskSourcePanes, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: item.key,
                  label: item.label,
                  name: item.key
                }, {
                  label: _withCtx(() => [
                    _createElementVNode("div", {
                      style: _normalizeStyle(
                _ctx.sourceData.any(
                  (it) =>
                    (item.key == 'Current' ? it.id == _ctx.id : it.id != _ctx.id) &&
                    it.tasks?.any(
                      (t) =>
                        t.Status == _ctx.EnumOrderTaskStatus.Executing &&
                        t.UserId == _ctx.logier?.CompanyUserId
                    )
                )
                  ? 'color: orange'
                  : ''
              )
                    }, _toDisplayString(item.label), 5)
                  ]),
                  _: 2
                }, 1032, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.taskSource == 'PoolSource')
            ? (_openBlock(), _createBlock(_component_el_tabs, {
                key: 0,
                modelValue: _ctx.poolTaskSource,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.poolTaskSource) = $event)),
                type: "card",
                "tab-position": "top"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.poolTaskSourcePanes, (item) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: item.key,
                      label: item.label,
                      name: item.key
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", {
                          style: _normalizeStyle(
                _ctx.sourceData
                  .firstOrDefault((it) => it.id == item.key)
                  ?.tasks?.any(
                    (it) =>
                      it.Status == _ctx.EnumOrderTaskStatus.Executing &&
                      it.UserId == _ctx.logier?.CompanyUserId
                  )
                  ? 'color: orange'
                  : ''
              )
                        }, _toDisplayString(item.label), 5)
                      ]),
                      _: 2
                    }, 1032, ["label", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_miezz_page_list, {
            modelValue: _ctx.list,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.list) = $event))
          }, {
            column: _withCtx(({ model, row }) => [
              (
              model.Prop == 'UserId' &&
              (row.Status == _ctx.EnumOrderTaskStatus.Executing ||
                row.Status == _ctx.EnumOrderTaskStatus.Canceled) &&
              ((row.PoolId &&
                _ctx.powers.contains('OrderManagement_Pool_Task_AssignUser')) ||
                (row.OrderId &&
                  _ctx.powers.contains('OrderManagement_Order_AssignUser')))
            )
                ? (_openBlock(), _createBlock(_component_miezz_button, {
                    key: 0,
                    model: {
              Code: 'assign-user',
              Label: row.UserLabel ?? '暂无数据',
              Type: 'text',
              Size: 'small',
            },
                    style: _normalizeStyle(`${
              !_ctx.onlyMy && row.UserId == _ctx.logier?.CompanyUserId
                ? 'color: #fe995b;'
                : ''
            }`),
                    onHandleClick: (arg1, arg2) => _ctx.handleRowButtonClick(arg1, row, arg2)
                  }, null, 8, ["model", "style", "onHandleClick"]))
                : (model.Prop == 'UserId')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      style: _normalizeStyle(`${
              !_ctx.onlyMy && row.UserId == _ctx.logier?.CompanyUserId
                ? 'color: #fe995b;'
                : ''
            }`)
                    }, _toDisplayString(row.UserLabel ?? "暂无数据"), 5))
                  : (
              model.Prop == 'Status' &&
              row.Status == _ctx.EnumOrderTaskStatus.Executing &&
              row.UserId == _ctx.logier?.CompanyUserId
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: ($event: any) => (_ctx.handleRowCommand(model.Prop, row))
                      }, "马上处理", 8, _hoisted_2))
                    : (
              model.Prop == 'Status' &&
              row.Status == _ctx.EnumOrderTaskStatus.Executing
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 待处理 "))
                      : (
              model.Prop == 'Status' &&
              row.Status == _ctx.EnumOrderTaskStatus.Completed
            )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已完成 " + _toDisplayString(_ctx.formatTime(
                row.CompletedTime ? row.CompletedTime : row.LastModifiedTime
              )), 1))
                        : (_ctx.cancel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已取消"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, "暂未开始"))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalAssign,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalAssign) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ref-form-assign",
          model: _ctx.modalAssignData,
          rules: _ctx.modalAssignRules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "CustomerServiceId",
              label: "执行人"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_miezz_select, {
                  modelValue: _ctx.modalAssignData.UserId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalAssignData.UserId) = $event)),
                  label: _ctx.modalAssignData.UserLabel,
                  "onUpdate:label": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalAssignData.UserLabel) = $event)),
                  options: _ctx.users,
                  clearable: false
                }, null, 8, ["modelValue", "label", "options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}